import AppForm from "components/AppForm/AppForm";
import CrudPage from "components/CrudPage/CrudPage";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import withRouter from "hoc/withRouter";
import { useLoadAll } from "hooks/useLoadAll";
import { useGetBaggageTrips } from "hooks/useGetBaggageTrips";
import inputTypeEnum from "enums/inputTypes";
import { snack } from "components/Snack/Snack";
import baggageService from "services/admin/baggageService";
import { BAGGAGE_TYPE_OPTIONS } from "./baggage-status";

interface BaggageFormProps {
  router: any;
  data: any;
}

const BaggageForm = ({ router, data }: BaggageFormProps) => {
  const {
    navigate,
    params: { id },
    queryParams,
  } = router;
  const { baggage } = data;
  const orgID = localStorage.getItem("orgID") || "";

  const { data: tripsResponse } = useGetBaggageTrips({ orgID });
  const trips = (tripsResponse as any)?.data || [];

  const tripOptions = trips.map((t: any) => {
    const route = `${t.originStation?.name || "—"} → ${t.destinationStation?.name || "—"}`;
    const train = t.train?.number ? `поезд ${t.train.number}, ` : "";
    return { id: t.id, name: `#${t.id} · ${train}${route}` };
  });

  const fieldsWithData = [
    {
      key: "tripID",
      label: "Отправка",
      required: true,
      inputType: inputTypeEnum.select,
      options: tripOptions,
    },
    {
      key: "tagCode",
      label: "Код бирки (пусто — сгенерируется автоматически)",
      inputType: inputTypeEnum.text,
    },
    {
      key: "type",
      label: "Тип места",
      inputType: inputTypeEnum.select,
      options: BAGGAGE_TYPE_OPTIONS,
    },
    {
      key: "weight",
      label: "Вес (кг)",
      inputType: inputTypeEnum.number,
      options: { min: 0 },
    },
    {
      key: "description",
      label: "Описание",
      inputType: inputTypeEnum.text,
    },
  ];

  // При создании из списка поездки tripID может прийти query-параметром
  const presetTripID = queryParams?.tripID ? Number(queryParams.tripID) : undefined;
  const formData = baggage || (presetTripID ? { tripID: presetTripID } : undefined);

  const onSubmit = async (formValues: any) => {
    try {
      if (baggage) {
        await baggageService.put(id, formValues);
        snack("Багаж обновлён успешно!");
      } else {
        await baggageService.post(formValues);
        snack("Багаж зарегистрирован успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex);
    }
  };

  return (
    <CrudPage title={baggage ? "Редактирование багажа" : "Регистрация багажа"}>
      <AppForm onSubmit={onSubmit} data={formData} fields={fieldsWithData}></AppForm>
    </CrudPage>
  );
};
export default withRouter(
  withRemoteDataAndSpinner(BaggageForm, (router: any) => {
    let requests: any = {};
    if (router.params.id) {
      requests["baggage"] = () => baggageService.get(router.params.id);
    }
    return useLoadAll(requests);
  }),
);
